<template>
    <div>
        <div class="nav-vertical">
			<ul class="nav nav-tabs nav-left" role="tablist">
				<li class="nav-item">
					<a class="nav-link active" v-bind:href="'#t1'+rowData.id+''" role="tab" data-toggle="tab">
						<span class="nav-link-in">
							Permissões Vinculadas
							<i class="fa fa-bulding"></i>
						</span>
					</a>
				</li>
                <li class="nav-item">
					<a class="nav-link" v-bind:href="'#t2'+rowData.id+''" role="tab" data-toggle="tab">
						<span class="nav-link-in">
							Usuários Vinculados
							<i class="fa fa-bulding"></i>
						</span>
					</a>
				</li>
			</ul>

			<div class="tab-content">
				<div role="tabpanel" class="tab-pane fade in active show pt-1 border-color-detalhes-grey" v-bind:id="'t1'+rowData.id+''">
                    <table class="table-striped" id="mais">
                        <thead>
                            <tr>
                                <th style="width: 10%">Código</th>
                                <th style="width: 20%">Nome</th>
                                <th style="width: 20%">Descrição</th>
                                <th style="width: 10%">Tipo</th>
                                <th style="width: 10%">Status</th>
                                <th style="width: 10%">Ações</th>
                            </tr>
                         </thead>
                         <tbody>
                             <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.role_has_permissions">
                                <td>
                                    {{ item.permission.cd }}
                                </td>
                                <td>
                                    {{ item.permission.name }}
                                </td>
                                <td>
                                    {{ item.permission.descr }}
                                </td>
                                <td>
                                    <span class="label label-primary">{{ item.permission.tp_permission.descr }}</span>
                                </td>
                                <td>
                                    <span class="label label-success" v-if="item.permission.status.valor==1">{{ item.permission.status.descr }}</span>
                                    <span class="label label-danger" v-if="item.permission.status.valor==2">{{ item.permission.status.descr }}</span>
                                </td>
                                <td>
                                    <a @click="onDestroy(item, false)" v-b-tooltip title="Excluir"><i class="fa fa-trash"></i></a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div><!--.tab-pane-->

                <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey" v-bind:id="'t2'+rowData.id+''">
                    <table class="table-striped" id="mais">
                        <thead>
                            <tr>
                                <th style="width: 50%">Nome</th>
                                <th style="width: 40%">Email</th>
                                <th style="width: 10%">Status Usuário</th>
                            </tr>
                         </thead>
                         <tbody>
                             <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.model_has_roles">
                                <td>
                                    <span v-if="item.usuario.pessoa">
                                    {{ item.usuario.pessoa.pessoa_fisica.nome }}
                                    </span>
                                </td>
                                <td>
                                    {{ item.usuario.email }}
                                </td>
                                <td>
                                    {{ item.usuario.status.descr }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div><!--.tab-pane-->
            </div><!--.tab-content-->
		</div>
    </div>
</template>

  <script>
  export default {
      data () {
        return {
          helpForm: new Form({permissionRole: [], params: []}),
        }
    },
    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
    methods: {
        onDestroy(data, tipo)
        {
            // Tipo = true = Checkbox
            // Destroy apenas na linha
            if(!tipo)
            {
                this.helpForm.permissionRole = [];
                this.helpForm.permissionRole.push({ permission_id: data.permission_id, role_id: data.role_id });
            }

            this.helpForm.post('/api/role/permission/destroy').then(response =>
            {
                this.$events.fire('reloadResponse', response);
            })
            .catch(errors =>
            {
                this.$events.fire('reloadResponse', errors);
            });

        },
    },
  }
  </script>
